import React, { forwardRef, useLayoutEffect, useRef, useState } from 'react';
import {
  Stethoscope, Droplet, Ship, Anchor, FlaskConical, Activity, ClipboardList, Users, HeartPulse, Pill,
  Brain, Bone, Baby, Eye, Smile, Microscope, Ambulance, Plane, Home, ShieldCheck, Clock, RefreshCw,
  Syringe, Phone, MapPin, Globe, Heart, HandHeart, Scan, Thermometer, Apple, FileText,
  HeartHandshake, UsersRound, Sprout, MessagesSquare, MessageCircleHeart, UserRound, ClipboardCheck, Puzzle, Sun,
  Leaf, Sofa, Lightbulb, Target, TrendingUp, Footprints, Flower2, Ear, Speech, School, GraduationCap, Handshake,
  ShieldPlus, BrainCircuit, Sparkles, PersonStanding, Accessibility, Dumbbell, Hospital, BedDouble, Wind, HeartCrack,
  Moon, Cigarette, Wine, Award, CalendarCheck, Video, Languages, Salad, Weight, Dna, TestTube, Bandage,
} from 'lucide-react';

export const CARD_ICONS = {
  stethoscope: Stethoscope, drip: Droplet, ship: Ship, anchor: Anchor, lab: FlaskConical, activity: Activity,
  clipboard: ClipboardList, users: Users, heart: HeartPulse, pill: Pill, brain: Brain, bone: Bone, baby: Baby,
  eye: Eye, dental: Smile, microscope: Microscope, ambulance: Ambulance, plane: Plane, home: Home,
  shield: ShieldCheck, clock: Clock, refresh: RefreshCw, syringe: Syringe, scan: Scan, thermo: Thermometer,
  nutrition: Apple, document: FileText,
  therapy: Sofa, psyche: MessageCircleHeart, couple: HeartHandshake, family: UsersRound, group: MessagesSquare,
  assessment: ClipboardCheck, mindmap: BrainCircuit, support: HandHeart, parents: Baby, growth: Sprout,
  person: UserRound, puzzle: Puzzle, sun: Sun, leaf: Leaf, idea: Lightbulb, target: Target, progress: TrendingUp,
  steps: Footprints, flower: Flower2, listen: Ear, speech: Speech, school: School, education: GraduationCap,
  handshake: Handshake, protect: ShieldPlus, sparkles: Sparkles, posture: PersonStanding, accessibility: Accessibility,
  fitness: Dumbbell, hospital: Hospital, bed: BedDouble, breath: Wind, heartbreak: HeartCrack, sleep: Moon,
  smoking: Cigarette, alcohol: Wine, award: Award, calendar: CalendarCheck, video: Video, languages: Languages,
  diet: Salad, weight: Weight, dna: Dna, testtube: TestTube, bandage: Bandage,
};

export const CARD_ICON_LABELS = {
  stethoscope: 'Στηθοσκόπιο', drip: 'Ορός / Σταγόνα', ship: 'Πλοίο', anchor: 'Άγκυρα', lab: 'Εργαστήριο',
  activity: 'Καρδιογράφημα', clipboard: 'Φάκελος / Λίστα', users: 'Άνθρωποι', heart: 'Καρδιά', pill: 'Φάρμακο',
  brain: 'Εγκέφαλος', bone: 'Οστό', baby: 'Μωρό / Παιδί', eye: 'Μάτι', dental: 'Χαμόγελο / Δόντια',
  microscope: 'Μικροσκόπιο', ambulance: 'Ασθενοφόρο', plane: 'Αεροπλάνο', home: 'Σπίτι', shield: 'Ασπίδα / Προστασία',
  clock: 'Ρολόι', refresh: 'Παραπομπή / Ανανέωση', syringe: 'Σύριγγα / Εμβόλιο', scan: 'Απεικόνιση', thermo: 'Θερμόμετρο',
  nutrition: 'Μήλο / Διατροφή', document: 'Έγγραφο / Πιστοποιητικό',
  therapy: 'Ψυχοθεραπεία (καναπές)', psyche: 'Συζήτηση με καρδιά', couple: 'Ζευγάρι / Θεραπεία ζεύγους',
  family: 'Οικογένεια', group: 'Ομαδική συζήτηση', assessment: 'Αξιολόγηση / Διάγνωση', mindmap: 'Νους / Σκέψη',
  support: 'Υποστήριξη (χέρι με καρδιά)', parents: 'Γονείς & Παιδί', growth: 'Προσωπική ανάπτυξη (βλαστάρι)',
  person: 'Άτομο', puzzle: 'Παζλ / Λύση', sun: 'Ήλιος / Αισιοδοξία', leaf: 'Φύλλο / Ηρεμία', idea: 'Ιδέα / Λάμπα',
  target: 'Στόχος', progress: 'Πρόοδος', steps: 'Βήματα', flower: 'Λουλούδι / Ευεξία', listen: 'Ακρόαση (αυτί)',
  speech: 'Λόγος / Λογοθεραπεία', school: 'Σχολείο', education: 'Εκπαίδευση', handshake: 'Χειραψία / Συνεργασία',
  protect: 'Ασπίδα με σταυρό', sparkles: 'Λάμψη / Αισθητική', posture: 'Στάση σώματος', accessibility: 'Αναπηρία / Προσβασιμότητα',
  fitness: 'Άσκηση', hospital: 'Νοσοκομείο', bed: 'Κρεβάτι / Νοσηλεία', breath: 'Αναπνοή', heartbreak: 'Συναισθηματική δυσκολία',
  sleep: 'Ύπνος', smoking: 'Κάπνισμα / Διακοπή', alcohol: 'Αλκοόλ / Εξαρτήσεις', award: 'Βραβείο / Πιστοποίηση',
  calendar: 'Ραντεβού / Ημερολόγιο', video: 'Online συνεδρία (βίντεο)', languages: 'Γλώσσες / Διερμηνεία',
  diet: 'Σαλάτα / Δίαιτα', weight: 'Βάρος', dna: 'DNA / Γενετική', testtube: 'Δοκιμαστικός σωλήνας', bandage: 'Επίδεσμος / Τραύματα',
};

export const CARD_FORMATS = { story: { w: 1080, h: 1920 }, post: { w: 1080, h: 1350 } };

const GOLD = '#d4af37';
const GOLD_GRAD = 'linear-gradient(180deg, #f7e08a 0%, #d4af37 45%, #a67c1a 100%)';
const NAVY = '#0a1628';
const BG = '#0c1d2f';
const SANS = "'Fira Sans Condensed', 'Inter', sans-serif";
const SERIF = "'Noto Serif', 'Cormorant Garamond', serif";

export const CARD_FONTS = {
  fira: { label: 'Στενή (Fira Sans Condensed)', css: SANS },
  noto: { label: 'Κλασική (Noto Serif)', css: SERIF },
  opensans: { label: 'Απλή (Open Sans)', css: "'Open Sans', sans-serif" },
  didot: { label: 'Κομψή (GFS Didot)', css: "'GFS Didot', serif" },
  manrope: { label: 'Μοντέρνα (Manrope)', css: "'Manrope', sans-serif" },
  comfortaa: { label: 'Στρογγυλή (Comfortaa)', css: "'Comfortaa', sans-serif" },
};

const ts = (d, key, defFont, defBold) => {
  const o = (d.styles || {})[key] || {};
  return {
    fontFamily: (CARD_FONTS[o.font] || {}).css || defFont,
    k: (o.size ?? 100) / 100,
    fontWeight: (o.bold ?? defBold) ? 700 : 400,
    fontStyle: o.italic ? 'italic' : 'normal',
    transform: `translate(${o.x || 0}px, ${o.y || 0}px)`,
  };
};

const Divider = ({ width = 420 }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 14, width, margin: '0 auto' }}>
    <div style={{ flex: 1, height: 2, background: `linear-gradient(90deg, transparent, ${GOLD})` }} />
    <Heart size={26} fill={GOLD} color={GOLD} />
    <div style={{ flex: 1, height: 2, background: `linear-gradient(90deg, ${GOLD}, transparent)` }} />
  </div>
);

const Header = ({ s }) => (
  <>
    <img src="/card/logo-transparent.png" alt="" style={{ position: 'absolute', left: 34, top: s.logoTop, width: 430 * s.k }} />
    <div style={{ position: 'absolute', right: 30, top: s.titleTop, width: 540, textAlign: 'center' }}>
      <div style={{ fontFamily: SERIF, fontWeight: 700, fontSize: 50 * s.k, lineHeight: 1.15, whiteSpace: 'nowrap', background: GOLD_GRAD, WebkitBackgroundClip: 'text', color: 'transparent' }}>
        ΓΝΩΡΙΣΤΕ ΤΟΥΣ<br />ΣΥΝΕΡΓΑΤΕΣ ΜΑΣ
      </div>
      <div style={{ marginTop: 18 * s.k }}><Divider width={460} /></div>
    </div>
  </>
);

const Photo = ({ d, box }) => (
  <div style={{ position: 'absolute', ...box, borderRadius: 28, border: `6px solid ${GOLD}`, overflow: 'hidden', background: '#1a2740', boxShadow: '0 20px 50px rgba(0,0,0,0.6)' }}>
    {d.photo && (
      <img
        src={d.photo}
        alt=""
        crossOrigin="anonymous"
        style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: `${d.photoX ?? 50}% ${d.photoY ?? 30}%`, transform: `scale(${(d.photoZoom ?? 100) / 100})`, transformOrigin: `${d.photoX ?? 50}% ${d.photoY ?? 30}%` }}
      />
    )}
  </div>
);

const NameBanner = ({ d, box, k }) => {
  const tn = ts(d, 'name', SANS, true);
  const tt = ts(d, 'title', SANS, true);
  return (
  <div style={{ position: 'absolute', ...box, borderRadius: 18, background: GOLD_GRAD, boxShadow: '0 12px 30px rgba(0,0,0,0.55)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '0 20px', textAlign: 'center' }}>
    <div style={{ fontFamily: tn.fontFamily, fontWeight: tn.fontWeight, fontStyle: tn.fontStyle, transform: tn.transform, fontSize: 58 * k * tn.k, color: NAVY, lineHeight: 1.05, textTransform: 'uppercase' }}>{d.name}</div>
    <div style={{ width: '70%', height: 2, background: NAVY, opacity: 0.5, margin: `${10 * k}px 0` }} />
    <div style={{ fontFamily: tt.fontFamily, fontWeight: tt.fontWeight, fontStyle: tt.fontStyle, transform: tt.transform, fontSize: 34 * k * tt.k, color: NAVY, textTransform: 'uppercase', letterSpacing: 1 }}>{d.title}</div>
  </div>
  );
};

const Services = ({ d, box, k, max }) => {
  const list = (d.services || []).filter((x) => x.text).slice(0, max);
  const tsv = ts(d, 'services', SANS, false);
  const total = list.reduce((n, x) => n + x.text.length, 0) / (box.height / 880);
  const fs = (total > 560 ? 21 : total > 460 ? 23 : total > 360 ? 25 : 27) * k;
  return (
    <div style={{ position: 'absolute', ...box, border: `3px solid ${GOLD}`, borderRadius: 26, background: 'rgba(10,22,40,0.78)', padding: `${22 * k}px ${22 * k}px`, display: 'flex', flexDirection: 'column' }}>
      <div style={{ fontFamily: SERIF, fontWeight: 700, fontSize: 40 * k, color: GOLD, textAlign: 'center' }}>ΟΙ ΥΠΗΡΕΣΙΕΣ ΜΑΣ</div>
      <div style={{ margin: `${8 * k}px 0 ${10 * k}px` }}><Divider width={300} /></div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', transform: tsv.transform }}>
        {list.map((sv, i) => {
          const Ico = CARD_ICONS[sv.icon] || Stethoscope;
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 18 * k, paddingBottom: 8 * k, borderBottom: i < list.length - 1 ? '1px solid rgba(212,175,55,0.35)' : 'none' }}>
              <div style={{ flexShrink: 0, width: 66 * k, height: 66 * k, borderRadius: '50%', border: `3px solid ${GOLD}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Ico size={36 * k} color={GOLD} strokeWidth={1.8} />
              </div>
              <div style={{ fontFamily: tsv.fontFamily, fontWeight: tsv.fontWeight, fontStyle: tsv.fontStyle, fontSize: fs * tsv.k, lineHeight: 1.2, color: '#fff' }}>{sv.text}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const InfoBox = ({ d, icon: Ico, label, lines, box, k }) => {
  const tb = ts(d, 'boxes', SANS, false);
  return (
  <div style={{ position: 'absolute', ...box, border: `3px solid ${GOLD}`, borderRadius: 20, background: 'rgba(10,22,40,0.88)', display: 'flex', alignItems: 'center', gap: 14 * k, padding: `0 ${16 * k}px` }}>
    <Ico size={44 * k} color={GOLD} strokeWidth={2} style={{ flexShrink: 0 }} />
    <div style={{ minWidth: 0, transform: tb.transform }}>
      <div style={{ fontFamily: tb.fontFamily, fontWeight: 700, fontStyle: tb.fontStyle, fontSize: 25 * k * tb.k, color: GOLD, textTransform: 'uppercase' }}>{label}</div>
      {String(lines || '').split('\n').map((l, i) => (
        <div key={i} style={{ fontFamily: tb.fontFamily, fontWeight: tb.fontWeight, fontStyle: tb.fontStyle, fontSize: 25 * k * tb.k, color: '#fff', lineHeight: 1.25, wordBreak: 'break-word' }}>{l}</div>
      ))}
    </div>
  </div>
  );
};

const GoldLine = ({ top, t }) => (
  <div style={{ position: 'absolute', left: 0, right: 0, top, height: t, background: 'linear-gradient(90deg, #a67c1a, #f7e08a 50%, #a67c1a)' }} />
);

const BottomBar = ({ top, h, wave }) => {
  const C = wave ? NAVY : GOLD;
  return (
  <div style={{ position: 'absolute', left: 0, right: 0, top, height: h, background: wave ? GOLD_GRAD : 'rgba(8,19,31,0.9)', display: 'flex', alignItems: 'center', padding: '0 30px', gap: 20, color: C, fontFamily: SANS }}>
    <div style={{ flex: 1.25, display: 'flex', alignItems: 'center', gap: 14 }}>
      <HandHeart size={54} color={C} strokeWidth={1.8} style={{ flexShrink: 0 }} />
      <div style={{ fontSize: 23, fontWeight: 600, lineHeight: 1.2 }}>Συνδέουμε τους ασθενείς<br />με τη φροντίδα που αξίζουν.</div>
    </div>
    <div style={{ width: 2, height: '55%', background: C, opacity: 0.5 }} />
    <div style={{ flex: 1.1, display: 'flex', alignItems: 'center', gap: 12 }}>
      <Globe size={44} color={C} style={{ flexShrink: 0 }} />
      <div style={{ fontSize: 24, fontWeight: 700 }}>www.jhouseofsecretary.com</div>
    </div>
    <div style={{ width: 2, height: '55%', background: C, opacity: 0.5 }} />
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 12 }}>
      <Phone size={44} color={C} style={{ flexShrink: 0 }} />
      <div style={{ fontSize: 23, fontWeight: 700, lineHeight: 1.25, whiteSpace: 'nowrap' }}>ΤΑ ΤΗΛΕΦΩΝΑ ΜΑΣ:<br />22321316 / 99931264</div>
    </div>
  </div>
  );
};

export const CARD_LANGUAGES = {
  gr: 'Ελληνικά', gb: 'Αγγλικά', ru: 'Ρωσικά', fr: 'Γαλλικά', de: 'Γερμανικά', it: 'Ιταλικά', es: 'Ισπανικά',
  sa: 'Αραβικά', il: 'Εβραϊκά', ro: 'Ρουμανικά', bg: 'Βουλγαρικά', ua: 'Ουκρανικά', tr: 'Τουρκικά', cn: 'Κινέζικα',
  in: 'Χίντι', ph: 'Φιλιππινέζικα', rs: 'Σερβικά', pl: 'Πολωνικά', am: 'Αρμενικά', ge: 'Γεωργιανά', ir: 'Περσικά',
  pt: 'Πορτογαλικά', nl: 'Ολλανδικά', se: 'Σουηδικά',
};

const hasLangs = (d) => (d.languages || []).length > 0;

const Langs = ({ d, top, k, left, width }) => {
  if (!hasLangs(d)) return null;
  const tl = ts(d, 'langs', SANS, true);
  return (
    <div style={{ position: 'absolute', left, top, width, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 * k, flexWrap: 'nowrap', transform: tl.transform }}>
      <span style={{ fontFamily: tl.fontFamily, fontWeight: tl.fontWeight, fontStyle: tl.fontStyle, fontSize: 24 * k * tl.k, color: GOLD, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{d.langLabel ?? 'Γλώσσες επικοινωνίας'}:</span>
      {d.languages.slice(0, 8).map((c) => (
        <img key={c} src={`/card/flags/${c}.png`} alt={c} style={{ width: 46 * k, height: 31 * k, objectFit: 'cover', borderRadius: 4, border: `2px solid ${GOLD}` }} />
      ))}
    </div>
  );
};

const Bio = ({ d, box, k, short }) => {
  const paras = String(d.bio || '').split(/\n\s*\n/).filter(Boolean).slice(0, short ? 1 : 3);
  const len = paras.join(' ').length * (short ? 1.6 : 1);
  const tbio = ts(d, 'bio', SANS, false);
  const base = (len > 420 ? 23 : len > 320 ? 25 : len > 240 ? 28 : 31) * k * tbio.k;
  const ref = useRef(null);
  const [fs, setFs] = useState(base);
  const maxH = box.height || (short ? 130 : 340);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    let size = base;
    el.style.fontSize = `${size}px`;
    while (el.scrollHeight > maxH && size > 14) { size -= 1; el.style.fontSize = `${size}px`; }
    setFs(size);
  }, [d.bio, base, maxH, tbio.fontFamily, tbio.fontWeight]);
  return (
    <div ref={ref} style={{ position: 'absolute', ...box, height: maxH, fontFamily: tbio.fontFamily, fontWeight: tbio.fontWeight, fontStyle: tbio.fontStyle, transform: tbio.transform, color: '#fff', fontSize: fs, lineHeight: 1.3 }}>
      {paras.map((p, i) => (
        <div key={i}>
          {i > 0 && <div style={{ margin: `${12 * k}px 0` }}><Divider width={380} /></div>}
          <div>{p}</div>
        </div>
      ))}
    </div>
  );
};

const Intro = ({ d, box, k }) => {
  const ti = ts(d, 'intro', SANS, false);
  return (
  <div style={{ position: 'absolute', ...box, fontFamily: ti.fontFamily, fontWeight: ti.fontWeight, fontStyle: ti.fontStyle, transform: ti.transform, color: '#fff', fontSize: 33 * k * ti.k, lineHeight: 1.3, textAlign: 'center' }}>
    Σας παρουσιάζουμε τους ιατρούς που συνεργάζονται με τη <span style={{ color: GOLD, fontWeight: 700 }}>J.House of Secretary</span>, με στόχο την καλύτερη εξυπηρέτηση και φροντίδα της υγείας σας.
  </div>
  );
};

const StoryLayout = ({ d }) => (
  <>
    <Header s={{ k: 1, logoTop: 60, titleTop: 130 }} />
    <Intro d={d} box={{ left: 590, top: 300, width: 460 }} k={0.92} />
    <Photo d={d} box={{ left: 30, top: 300, width: 535, height: 650 }} />
    <NameBanner d={d} box={{ left: 22, top: 930, width: 551, height: 175 }} k={1} />
    <Langs d={d} top={1112} k={1} left={22} width={551} />
    <Bio d={d} box={{ left: 36, top: hasLangs(d) ? 1185 : 1130, width: 525, height: hasLangs(d) ? 285 : 340 }} k={1} />
    <Services d={d} box={{ left: 585, top: 520, width: 465, height: 950 }} k={1} max={8} />
    <InfoBox d={d} icon={Phone} label={d.phonesLabel ?? 'Τηλέφωνα επικοινωνίας'} lines={d.phones} box={{ left: 30, top: 1490, width: 370, height: 135 }} k={1} />
    <InfoBox d={d} icon={MapPin} label={d.locationLabel ?? 'Τοποθεσία ιατρείου'} lines={d.location} box={{ left: 412, top: 1490, width: 300, height: 135 }} k={1} />
    {(String(d.follow || '').trim() || String(d.followLabel ?? '').trim()) && <InfoBox d={d} icon={Globe} label={d.followLabel ?? 'Follow us on'} lines={d.follow} box={{ left: 724, top: 1490, width: 326, height: 135 }} k={1} />}
    <BottomBar top={1760} h={160} wave={d.decor === 'wave'} />
    {d.decor !== 'wave' && <GoldLine top={1760} t={d.lineT ?? 3} />}
    {d.decor !== 'wave' && <GoldLine top={1920 - (d.lineT ?? 3)} t={d.lineT ?? 3} />}
  </>
);

const PostLayout = ({ d }) => (
  <>
    <Header s={{ k: 0.82, logoTop: 20, titleTop: 70 }} />
    <Photo d={d} box={{ left: 40, top: 250, width: 470, height: 520 }} />
    <NameBanner d={d} box={{ left: 32, top: 740, width: 486, height: 150 }} k={0.86} />
    <Langs d={d} top={896} k={0.8} left={32} width={486} />
    <Bio d={d} box={{ left: 44, top: hasLangs(d) ? 950 : 915, width: 466, height: hasLangs(d) ? 100 : 135 }} k={0.82} short />
    <Services d={d} box={{ left: 535, top: 250, width: 505, height: 790 }} k={0.84} max={7} />
    <InfoBox d={d} icon={Phone} label={d.phonesLabel ?? 'Τηλέφωνα επικοινωνίας'} lines={d.phones} box={{ left: 40, top: 1065, width: 345, height: 112 }} k={0.85} />
    <InfoBox d={d} icon={MapPin} label={d.locationLabel ?? 'Τοποθεσία ιατρείου'} lines={d.location} box={{ left: 397, top: 1065, width: 290, height: 112 }} k={0.85} />
    {(String(d.follow || '').trim() || String(d.followLabel ?? '').trim()) && <InfoBox d={d} icon={Globe} label={d.followLabel ?? 'Follow us on'} lines={d.follow} box={{ left: 699, top: 1065, width: 341, height: 112 }} k={0.85} />}
    <BottomBar top={1210} h={140} wave={d.decor === 'wave'} />
    {d.decor !== 'wave' && <GoldLine top={1210} t={d.lineT ?? 3} />}
    {d.decor !== 'wave' && <GoldLine top={1350 - (d.lineT ?? 3)} t={d.lineT ?? 3} />}
  </>
);

export const DoctorCardCanvas = forwardRef(({ d, format = 'story' }, ref) => {
  const { w, h } = CARD_FORMATS[format];
  const ws = (d.waveT ?? 100) / 100;
  return (
    <div
      ref={ref}
      data-testid={`doctor-card-canvas-${format}`}
      style={{ position: 'relative', width: w, height: h, overflow: 'hidden', background: `radial-gradient(ellipse at 50% 45%, #13283f 0%, ${BG} 60%, #08131f 100%)` }}
    >
      {d.decor === 'wave' && (
        <>
          <img src="/card/bg-top.jpg" alt="" style={{ position: 'absolute', left: 0, top: 0, width: w, height: 280 * ws, maskImage: 'linear-gradient(180deg, #000 70%, transparent)', WebkitMaskImage: 'linear-gradient(180deg, #000 70%, transparent)' }} />
          <img src="/card/bg-wave.jpg" alt="" style={{ position: 'absolute', left: 0, top: (format === 'story' ? 1629 : 1199) - 159 * ws, width: w, height: 318 * ws, maskImage: 'linear-gradient(180deg, transparent, #000 25%, #000 75%, transparent)', WebkitMaskImage: 'linear-gradient(180deg, transparent, #000 25%, #000 75%, transparent)' }} />
        </>
      )}
      <div style={{ position: 'absolute', left: 0, top: 0, width: w, height: format === 'story' ? 330 : 280, background: 'radial-gradient(ellipse 34% 62% at 22% 50%, rgba(8,19,31,0.95) 35%, transparent 80%), radial-gradient(ellipse 34% 58% at 76% 52%, rgba(8,19,31,0.95) 35%, transparent 80%)' }} />
      {format === 'story' ? <StoryLayout d={d} /> : <PostLayout d={d} />}
      {d.decor !== 'wave' && <GoldLine top={0} t={d.lineT ?? 3} />}
    </div>
  );
});
DoctorCardCanvas.displayName = 'DoctorCardCanvas';
